export default __webpack_public_path__ + "static/media/Nimitz_Hill_Pipeline.b3baaebb.jpg";